class BarLine {
  constructor(x_data, serData, color) {
    this.x_data = x_data;
    this.serData = serData;
    this.color = color;
  }

  setoptions() {
    let that = this;
    const legendData = this.serData.map(item => item.name)
    const unitData = this.serData.map(item => item.unit)
    return {
      tooltip: {
        trigger: 'axis',
        formatter: params => {
          let date;
          let obj = params.map((item, index) => {
            date = item.name;
            // 小圆点显示
            let dotColor = `<span style="display:inline-block;
            margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>`
            let html = '</br>'
            // return dotColor + item.seriesName + ":" + item.value + '(' + percent + '%' + ')' + html
            return dotColor + item.seriesName + " : " + item.value + " / Unit: " + unitData[index] + html
          });
          obj.unshift(date + '</br>')
          return obj.join('') // 去除','
        }
      },

      legend: {
        //修复bug标记 02
        type: 'scroll',
        bottom: "0",
        //
        data: legendData
      },

      grid: {
        x: 20,
        y: 30,
        x2: 20,
        y2: 30,
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: true,
        data: this.x_data
      },

      yAxis: [
        {
          type: 'value',
          "axisLine":{       //y轴
            "show":false
  
          },
          "axisTick":{       //y轴刻度线
            "show":false
          },
          // "splitLine": {     //网格线
          //   "show": false
          // }
        },
      ],

      series: this.serData
    }
  }
}


export default (x_data, serData, color = []) => {
  return new BarLine(x_data, serData, color).setoptions();
}